import { lazy } from 'react';

import AuthGuard from 'components/AuthGuard';
import Layout from 'layouts/RequestLayout';

const error404 = {
  component: lazy(() => import('views/Errors/Error404')),
};

const basePath = '/request';

const requestRoutes = {
  guard: AuthGuard,
  layout: Layout,
  path: basePath,
  routes: [
    {
      component: lazy(() => import('views/Request/Contract')),
      exact: true,
      path: `${basePath}/contract/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Device')),
      exact: true,
      path: `${basePath}/device/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Documents')),
      exact: true,
      path: `${basePath}/documents/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Finish')),
      exact: true,
      path: `${basePath}/finished/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/LoanIphone')),
      exact: true,
      path: `${basePath}/loan_device/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Identity')),
      exact: true,
      path: `${basePath}/:flowType/identity`,
    },
    {
      component: lazy(() => import('views/Request/Curp')),
      exact: true,
      path: `${basePath}/curp`,
    },
    {
      component: lazy(() => import('views/Request/Identity')),
      exact: true,
      path: `${basePath}/identity/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/ConfirmIdentity')),
      exact: true,
      path: `${basePath}/confirm_identity/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Info')),
      exact: true,
      path: `${basePath}/info/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Loan')),
      exact: true,
      path: `${basePath}/loan/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Products')),
      exact: true,
      path: `${basePath}/products/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Questions')),
      exact: true,
      path: `${basePath}/questions/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Relationships')),
      exact: true,
      path: `${basePath}/relationships/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Score')),
      exact: true,
      path: `${basePath}/score/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Software')),
      exact: true,
      path: `${basePath}/software/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Status')),
      exact: true,
      path: `${basePath}/status/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Verify')),
      exact: true,
      path: `${basePath}/verify/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Enrollment')),
      exact: true,
      path: `${basePath}/enrollment/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/EnrollmentDatacultr')),
      exact: true,
      path: `${basePath}/enrollment_datacultr/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/ConfirmEnrollment')),
      exact: true,
      path: `${basePath}/confirm_enrollment/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Evidence')),
      exact: true,
      path: `${basePath}/evidence/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/EvidenceTicket')),
      exact: true,
      path: `${basePath}/evidence_ticket/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/lockunlock')),
      exact: true,
      path: `${basePath}/lockunlock/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/LockUnlockDatacultr')),
      exact: true,
      path: `${basePath}/lockunlock_datacultr/:clientId`,
    },    
    {
      component: lazy(() => import('views/Request/BlockedUser')),
      exact: true,
      path: `${basePath}/blocked_user/:clientId`,
    },
    {
      component: lazy(() => import('views/Request/Retry')),
      exact: true,
      path: `${basePath}/retry/:clientId`,
    },
    error404,
  ],
};

export default requestRoutes;
